/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Images
import productImage from "assets/images/products/product-11.jpg";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { notificationActions } from "../../../../../../store/notification/notification-slice";
import MDBadge from "../../../../../../components/MDBadge";

function EventImage({ cover, status }) {

  const badgeMap = [
    {
      status: 0,
      content: "Draft",
      color: "info"
    },
    {
      status: 1,
      content: "Approved",
      color: "success"
    },
    {
      status: 2,
      content: "Pending",
      color: "warning"
    },
    {
      status: 3,
      content: "Rejected",
      color: "error"
    },
    {
      status: 4,
      content: "Active",
      color: "success"
    }
  ];

  return (
    <Card
      sx={{
        "&:hover .card-header": {
          transform: "translate3d(0, -50px, 0)"
        }
      }}
    >
      <MDBox
        position="relative"
        borderRadius="lg"
        mt={2}
        mx={2}
        className="card-header"
        sx={{ transition: "transform 300ms cubic-bezier(0.34, 1.61, 0.7, 1)" }}
      >
        <MDBadge badgeContent={badgeMap.find(e=>e.status===status)?.content } color={badgeMap.find(e=>e.status===status)?.color} variant="gradient" size="md" >
        <MDBox
          component="img"
          src={cover}
          alt="Event Cover Image"
          borderRadius="lg"
          shadow="sm"
          width="100%"
          height="100%"
          position="relative"
          mb={0}
        >

        </MDBox>
        </MDBadge>
      </MDBox>
      <MDBox textAlign="center" pt={2} pb={3} px={3}>
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          mt={-10}
          position="relative"
          zIndex={1}
        >
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default EventImage;
